import { MedicalTreatmentConsent, MedicalTreatmentConsentWithdrawCommand } from '@dreryk/egabinet-patient-frontend-api';

import { useCqrsCommand, UseCqrsCommandResult } from '@dreryk/command-query-react-common';
import { dispatchSnackbarPositiveEvent } from '@dreryk/react-components';

import { patientConsentsAndAuthorizationsTranslationKeys } from '../../../../translations';

type MedicalTreatmentConsentWithdrawCommandOptions = {
   patientId: number;
   onSuccess?: VoidFunction;
};

export const useMedicalTreatmentConsentWithdrawCommand = ({
   patientId,
   onSuccess,
}: MedicalTreatmentConsentWithdrawCommandOptions): UseCqrsCommandResult<MedicalTreatmentConsent, void> => {
   return useCqrsCommand(
      () => {
         const command = new MedicalTreatmentConsentWithdrawCommand();
         command.patientId = patientId;
         return command;
      },
      {
         onSuccess: () => {
            dispatchSnackbarPositiveEvent(
               patientConsentsAndAuthorizationsTranslationKeys.consent.consentHasBeenWithdrawn
            );
            onSuccess?.();
         },
      }
   );
};
